<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="31.998" height="32" viewBox="0 0 31.998 32">
    <path d="M16,8A16,16,0,1,0,32,24,16,16,0,0,0,16,8Zm7.857,10.961L21.231,31.335c-.194.877-.716,1.09-1.445.677l-4-2.948-1.929,1.858a1.01,1.01,0,0,1-.806.394l.284-4.071,7.412-6.7c.323-.284-.071-.445-.5-.161L11.09,26.155,7.141,24.923c-.858-.271-.877-.858.181-1.271L22.747,17.7C23.463,17.445,24.089,17.877,23.856,18.961Z" transform="translate(0 -8)" class="fill-current"/>
  </svg>
</template>
